import React, { useEffect } from "react";
import useSound from "use-sound";
import errorSFX from "../../../assets/audio/globals/errorSFX.mp3";
import {
  NoSignalContainer,
  NoSignalContent,
  NoSignalBox,
  NoSignalBtn,
} from "./noSignalStyled";
import { OPWrapper } from "../settings/SettingsStyled";


export default ({ Globals, errorMsg, userSettings }) => {
  const { mainText, btnText, reload } = errorMsg;
  const [playErrorSFX] = useSound(errorSFX, {
    volume: userSettings.volume,
  });
  useEffect(() => {
    if (userSettings.sound === "1") {
      playErrorSFX();
    }
  }, [playErrorSFX, userSettings.sound]);
  
  return (
    <NoSignalContainer>
      <OPWrapper>
        <NoSignalBox>
          <NoSignalContent reload={reload}>
            <p>{mainText}</p>
          </NoSignalContent>
          {btnText && reload ? (
            <NoSignalBtn
              onClick={() =>
                window.parent.postMessage(
                  JSON.stringify({ action: "reload" }),
                  "*"
                )
              }
            >
              {btnText}
            </NoSignalBtn>
          ) : btnText && !reload ? (
            <NoSignalBtn onClick={() => Globals.WS.Start()}>
              {btnText}
            </NoSignalBtn>
          ) : null}
        </NoSignalBox>
      </OPWrapper>
    </NoSignalContainer>
  );
};
